<template>
    <div class="component-upload-image">
      <el-upload
        :multiple="isMultiple"
        :action="uploadImgUrl"
        list-type="picture-card"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        :limit="limit"
        :on-error="handleUploadError"
        :on-exceed="handleExceed"
        ref="imageUpload"
        :before-remove="handleDelete"
        :show-file-list="true"
        :headers="headers"
        :file-list="fileList"
        :on-preview="handlePictureCardPreview"
        class="file-uploader"
        :class="{ 'hide-delete-button': disabled }"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
        <!-- 自定义每个文件卡片：图片上常驻“叉号”删除按钮 -->
        <template v-if="isPortrait" slot="file" slot-scope="{ file }">
          <div class="custom-upload-item">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            <!-- 上传中：显示 loading 蒙层 -->
            <div v-if="file.status === 'uploading'" class="custom-upload-loading">
              <i class="el-icon-loading"></i>
            </div>
            <!-- 右上角常驻叉号删除按钮 -->
            <div
              class="custom-upload-delete"
              @click.stop="handleCustomDelete(file)"
            >
              <img src="/assets/~/media/images/community/mob/cha.png" alt="">
            </div>
          </div>
        </template>
      </el-upload>
  
      <!-- 上传提示 -->
      <!-- <div class="el-upload__tip" v-if="showTip">
        <template v-if="fileType">
          支持格式：<b style="color: #f56c6c">{{ fileType.join('/') }}</b>
        </template>
        <template v-if="fileSize">
          ，单个文件不能超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
        </template>
        ，建议分辨率500*500px
      </div> -->
  
      <el-dialog :visible.sync="dialogVisible" title="预览" width="800px" append-to-body>
        <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ComponentUploadImage',
    props: {
      uploadImgUrl: {
        type: String,
        default: ''
      },
      uploadImgType: {
        type: String,
        default: null
      },
      value: [String, Object, Array],
      limit: {
        type: Number,
        default: 5
      },
      fileSize: {
        type: Number,
        default: 1
      },
      fileType: {
        type: Array,
        default: () => ['png', 'jpg']
      },
      isShowTip: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      imgKind: {
        type: String,
        default: ''
      },
      // tokenEnvironment: {
      //   type: String,
      //   default: ''
      // },
      headers: {
        type: Object,
        default: () => ({})
      },
      isPortrait: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        number: 0,
        uploadList: [],
        dialogImageUrl: '',
        dialogVisible: false,
        baseUrl: process.env.VUE_APP_BASE_API,
        fileList: [],
        isMultiple: true
      };
    },
    computed: {
      showTip() {
        return this.isShowTip && (this.fileType || this.fileSize);
      }
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            const list = Array.isArray(val) ? val : val.split(',');
            this.fileList = list.map(item => {
              if (typeof item === 'string') {
                if (!item.startsWith('http://') && !item.startsWith('https://')) {
                  return { name: this.baseUrl + item, url: this.baseUrl + item };
                }
                return { name: item, url: item };
              }
              return item;
            });
          } else {
            this.fileList = [];
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      this.setIsMultiple();
      window.addEventListener('pageshow', this.handlePageShow);
    },
    beforeDestroy() {
      window.removeEventListener('pageshow', this.handlePageShow);
    },
    methods: {
      handlePageShow() {
        this.setIsMultiple();
      },
      setIsMultiple() {
        var u = navigator.userAgent;
        var isAndroid = !!u.match(/Android/i) || !!u.match(/Linux/i);
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') !== -1;
        if(isAndroid && isWeixin){//安卓微信浏览器不支持多选
          this.isMultiple = false;
        }else{
          this.isMultiple = true;
        }
      },
      openFileDialog() {
        // Programmatically open the native file picker for el-upload
        // Works across ElementUI versions by clicking the underlying <input type="file">
        const uploadVm = this.$refs.imageUpload;
        const el = uploadVm && uploadVm.$el;
        const input =
          el && (el.querySelector('input[type="file"]') || el.querySelector('input'));
        if (input && typeof input.click === 'function') {
          input.click();
        }
      },
      handleBeforeUpload(file) {
        let isImg = false;
        if (this.fileType.length) {
          const fileExtension = file.name.split('.').pop().toLowerCase() || '';
          isImg = this.fileType.some(type => type.toLowerCase() === fileExtension);
        } else {
          isImg = file.type.startsWith('image/');
        }
        
        // if (!isImg) {
        //   this.$message.error(`文件格式不正确，请上传${this.fileType.join('/')}格式文件!`);
        //   return false;
        // }
  
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize;
          if (!isLt) {
            this.$message.error(`文件大小不能超过 ${this.fileSize}MB!`);
            return false;
          }
        }
  
        //this.$loading({ lock: true, text: '正在上传...', spinner: 'el-icon-loading' });
        this.number++;
        return true;
      },
  
      handleExceed() {
        this.$message.error(`最多只能上传 ${this.limit} 个文件!`);
      },
  
      handleUploadSuccess(res, file) {
        if (res.code === 200) {
          if(this.uploadImgType === 'community'){
            res.fileName = res.data.viewUrl;
          }
          if (this.uploadImgType === 'lottery') {
            res.fileName = res.data.startsWith('http') ? res.data : `http://${res.data}`;
          }
          this.uploadList.push({ name: res.fileName, url: res.fileName });
          this.uploadedSuccessfully();
        } else {
          this.number--;
          //this.$loading().close();
          this.$message.error(res.msg);
          this.$refs.imageUpload.handleRemove(file);
        }
      },
  
      handleDelete(file) {
        if (this.disabled) return false;
        const index = this.fileList.findIndex(f => f.uid === file.uid);
        if (index > -1) {
          this.fileList.splice(index, 1);
          this.$emit('input', {'img':this.listToString(this.fileList),'imgKind':this.imgKind});
        }
        return true;
      },
      // 自定义删除按钮：点击图片右上角“叉号”删除该图片
      handleCustomDelete(file) {
        if (this.disabled) return;
        const uploadVm = this.$refs.imageUpload;
        if (uploadVm && typeof uploadVm.handleRemove === 'function') {
          uploadVm.handleRemove(file);
        } else {
          // 兜底：直接走本地删除逻辑
          this.handleDelete(file);
        }
      },
  
      uploadedSuccessfully() {
        if (this.number > 0 && this.uploadList.length === this.number) {
            this.fileList = [...this.fileList, ...this.uploadList];
            this.uploadList = [];
            this.number = 0;
          
            const emitValue = this.uploadImgType === 'lottery' 
            ? (this.fileList[0].url || '') 
            : this.listToString(this.fileList);
          
            //   this.$emit('input', emitValue);
            this.$emit('input', {'img':emitValue,'imgKind':this.imgKind});
            //this.$loading().close();
        }
      },
  
      handleUploadError() {
        this.$message.error('上传失败');
        //this.$loading().close();
      },
  
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
  
      listToString(list, separator = ',') {
        return list
          .map(item => item.url.replace(this.baseUrl, '') || '')
          .filter(url => url && !url.startsWith('blob:'))
          .join(separator);
      },
  
      clearnFileList() {
        this.fileList = [];
        // this.$emit('input', '');
        this.$emit('input', {'img':'','imgKind':this.imgKind});
      }
    }
  };
  </script>
  
  <style scoped>
  @media (max-width: 768px) {
  .component-upload-image {
    position: relative;
  }
  
  /* 自定义图片卡片布局 */
  .custom-upload-item {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  
  .custom-upload-item .el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  
  /* 上传中的 loading 蒙层 */
  .custom-upload-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }
  .custom-upload-loading .el-icon-loading {
    font-size: 24px;
    color: #fff;
  }
  
  /* 图片右上角常驻“叉号”删除按钮 */
  .custom-upload-delete {
    position: absolute;
    right: 0px;
    top: 0px;
    width: calc(50 / 750 * 100vw);
    height: calc(50 / 750 * 100vw);
    background: #000;
    text-align: center;
    /* transform: rotate(45deg); */
    box-shadow: 0 0 1pc 1px rgba(0, 0, 0, .2);
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    border-radius: 0 0 0 calc(50 / 750 * 100vw);
    text-align: center;
    
  }
  .custom-upload-delete img {
      position: absolute;
      transform: translate(calc(-6 / 750 * 100vw), calc(10 / 750 * 100vw));
      width: calc(20 / 750 * 100vw);
      height: calc(20 / 750 * 100vw);
    }
  
  /* 允许图标溢出显示，并隐藏 Element 默认的状态/操作图标（包含勾选图标等） */
  ::v-deep .el-upload-list__item {
    overflow: visible;
  }
  
  ::v-deep .el-upload-list__item-status-label,
  ::v-deep .el-upload-list__item-actions {
    display: none;
  }
}
  </style>